// NATIVE
import * as React from 'react';

// INSTALLED
import { Grid } from '@mui/material';
import { Formik, Form } from 'formik';
import Dialog from '@mui/material/Dialog';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// CUSTOM
import { useDispatch } from 'react-redux';
import { SnackAlert } from '../../../SnackAlert';
import { timeToClosedToast } from '../../../../commons';
import MultipleSnackbars from '../../../MultipleSnackbars';
import { ModalSessionExpired } from '../../../generics/ModalSessionExpired';
import { closeSessionGlobal, hasPemissions, validateResponse } from '../../../../commons/utils';
import { storeEditTerminalEmpleados } from '../../../../store/terminals-empleados';
import editarTerminalFormModel from '../../../terminal/terminal-control-tiempo-descansos/formModels/editar/editarTerminalFormModel';
// import editarTerminalFormModel from '../../../terminal/terminal-descansos/formModels/editar/editarTerminalDescansosFormModel';
import validationSchema from '../../../terminal/terminal-control-tiempo-descansos/formModels/editar/validationSchema';
import formInitialValues from '../../../terminal/terminal-control-tiempo-descansos/formModels/editar/formInitialValues';
import { EditarTerminalDescansos } from '../../../terminal/terminal-control-tiempo-descansos/editar/EditarTerminalDescansos';
import { storeEditTerminalDescansos } from '../../../../store/terminal-descansos';
// import { EditarTerminalDescansos } from '../../../terminal/terminal-control-tiempo-empleados/editar/EditarTerminalEmpleados';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const EditarDialogTerminalDescansos = (props: any) => {
  // USE DISPATCH
  const dispatch = useDispatch();

  // USE STATE
  const [canEdit, setCanEdit] = React.useState<boolean>(false);
  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);

  const [alert_snack, setAlertSnack] = React.useState(false);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);

  const [txtBtnEditTerminal, setTxtBtnEditTerminal] = React.useState<string>('Editar Terminal');

  const [msgSnack, setMsgSnack] = React.useState({
    msg: '',
    status: 'success',
  });

  // PROPS
  const { open, handleCloseModalEditar, buttons = false, btnSubmiting } = props;

  // DATA MODELS
  const { formId, formField } = editarTerminalFormModel;
  const currentValidationSchema = validationSchema[0];

  // USE EFFECT
  React.useEffect(() => {
    checkEdit();
  }, [props]);

  React.useEffect(() => {
    setIsSubmiting(!open);
  }, [props]);

  // CONST FUNCTIONS
  const handleClose = () => {
    handleCloseModalEditar(false);
  };

  const checkEdit = async () => {
    const hasPermissionsEdit = await hasPemissions(
      'modulo.configuracion',
      'modulo.terminales',
      'edit'
    );

    if (hasPermissionsEdit) {
      setCanEdit(true);
    }
  };

  const _handleSubmit = async (values: any, actions: any) => {
    setTxtBtnEditTerminal('Un Monento...');
    actions.setSubmitting(true);
    setIsSubmiting(true);
    const response = await dispatch(storeEditTerminalDescansos(values));

    setTxtBtnEditTerminal('Editar Terminal');

    await validateResponse(
      response,
      'Editar Terminal',
      {
        setMsgSnack,
        setAlertSnack,
        setModalSessionExpired,
      },
      true
    );

    setIsSubmiting(false);

    if (!response.ok) {
      return false;
    }

    actions.setSubmitting(false);
    handleCloseModalEditar(false);
  };

  return (
    <React.Fragment>
      {/* *****************************************************************
       ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
       *********************************************************************/}
      <ModalSessionExpired open={modalSessionExpired} />
      <MultipleSnackbars
        messagesList={messagesAlerts}
        position={'bottom-left'}
        autoClose={timeAlert}
      />
      <SnackAlert
        open={alert_snack}
        onclick={setAlertSnack}
        text={msgSnack.msg}
        severity={msgSnack.status}
      />
      {/* ******************************************************************
       ******  COMPONENTS PARA MANEJAR MENSAJES DEL RESPONSE  **************
       *********************************************************************/}

      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          Editar Terminal Descansos
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid>
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              <>
                <Form id={formId}>
                  <EditarTerminalDescansos formField={formField} />

                  {canEdit && (
                    <Button
                      disabled={isSubmiting}
                      style={{ margin: 5, float: 'right' }}
                      type="submit"
                      variant="contained"
                      color={'primary'}
                    >
                      {txtBtnEditTerminal}
                    </Button>
                  )}
                </Form>
              </>
            </Formik>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};
